import { render, staticRenderFns } from "./QBR.vue?vue&type=template&id=7f8a3e2d&scoped=true&"
import script from "./QBR.vue?vue&type=script&lang=js&"
export * from "./QBR.vue?vue&type=script&lang=js&"
import style0 from "./QBR.vue?vue&type=style&index=0&id=7f8a3e2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a3e2d",
  null
  
)

export default component.exports